module.exports = __webpack_public_path__ + "static/media/fail.f129014d.png";